/**
 * VerticalMask component
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Vertical gradient mask.
 */
const VerticalMask = styled.div`
  background: linear-gradient(287deg, rgba(0, 0, 0, 0) 55.67%, #010101 77.89%);
  height: ${1066.627 * Screen.widthRatio}px;
  left: ${85 * Screen.widthRatio}px;
  position: absolute;
  top: 0;
  width: ${1854 * Screen.widthRatio}px;
  z-index: 1;
`;

export default withOpacity(VerticalMask);
